import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import PageWithTabs from 'modules/_shared/components/Pages/PageWithTabs';
import LetterTabConditionsView from './LetterTabConditionsView';
import LetterTabEditView from './LetterTabEditView';
import LetterTabDocumentPreviewView from './LetterTabDocumentPreviewView';

type Props = {
  planName: string;
  extraSignerName: string;
  extraSignerEmail: string;
  hasExtraSigner: boolean;
  htmlContent: string;
  attachmentFileName: string;
  attachmentFile: File | undefined;
  // eslint-disable-next-line no-unused-vars
  handleChangeHtmlContent: (content: string) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeExtraSignerName: (event: any) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeExtraSignerEmail: (event: any) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeAttachmentFile: (file: File) => void;
};

const LetterTabBody = ({
  planName,
  extraSignerName,
  extraSignerEmail,
  hasExtraSigner,
  htmlContent,
  attachmentFileName,
  attachmentFile,
  handleChangeHtmlContent,
  handleChangeExtraSignerName,
  handleChangeExtraSignerEmail,
  handleChangeAttachmentFile,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Modal.Body>
      <div className="nk-modal gy-4">
        <PageWithTabs
          tabs={[
            {
              key: 'letter-conditions-tab',
              icon: 'ni-list',
              title: t('Conditions'),
              content: (
                <LetterTabConditionsView
                  planName={planName}
                  extraSignerName={extraSignerName}
                  extraSignerEmail={extraSignerEmail}
                  hasExtraSigner={hasExtraSigner}
                  attachmentFileName={attachmentFileName}
                  attachmentFile={attachmentFile}
                  handleChangeExtraSignerName={handleChangeExtraSignerName}
                  handleChangeExtraSignerEmail={handleChangeExtraSignerEmail}
                  handleChangeAttachmentFile={handleChangeAttachmentFile}
                />
              ),
            },
            {
              key: 'letter-edit-tab',
              icon: 'ni-edit-alt',
              title: t('EditLetter'),
              content: (
                <LetterTabEditView
                  htmlContent={htmlContent}
                  handleChangeHtmlContent={handleChangeHtmlContent}
                />
              ),
            },
            {
              key: 'letter-preview-tab',
              icon: 'ni-file-docs',
              title: t('DocumentPreview'),
              content: <LetterTabDocumentPreviewView htmlContent={htmlContent} />,
            },
          ]}
        />
      </div>
    </Modal.Body>
  );
};

export default LetterTabBody;
